import { Injectable } from '@angular/core';
import { Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../web.service';


@Injectable()
export class SynergoCitationService extends WebService {

    public getSynergoCitation (page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        params.append('_with', String('requisition.employee,company,venue,profile_survey.checklist_profile_survey.list_doc_profile_survey,' +
        'document_profile_survey,profile_survey.checklist_profile_survey.document_profile_survey,candidate,hiring_analyst,citation_justification.user.employee'));

        const options = new RequestOptions({search: params, headers: this.headers});
        

        return this.http.get( `${this.apiUrl}/synergo-citations?${params}`, options);
    }

    public getSynergoCitationByRequisition (id: number,
        page?: number, per_page?: number, sort?: string, query?: string,
        filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        params.append('_with', String('requisition.employee,company,venue,profile_survey.checklist_profile_survey.list_doc_profile_survey,' +
        'document_profile_survey,profile_survey.checklist_profile_survey.document_profile_survey,candidate,hiring_analyst,citation_justification.user.employee'));

        const options = new RequestOptions({search: params, headers: this.headers});
        

        return this.http.get( `${this.apiUrl}/synergo-requisitions/${id}/synergo-citations?${params}`, options);
    }

    public newSynergoCitation(body: Object): Observable<Response> {
        return this.http.post( `${this.apiUrl}/synergo-citations`, JSON.stringify(body), { headers: this.headers } );
    }

    public updateSynergoCitation(id: number, body: Object): Observable<Response> {
        return this.http.patch( `${this.apiUrl}/synergo-citations/${id}`, JSON.stringify(body) , { headers: this.headers } );
    }

    public deleteSynergoCitation(id: number): Observable<Response> {
        return this.http.delete( `${this.apiUrl}/synergo-citations/${id}`, { headers: this.headers } );
    }

    public infoSynergoCitation(id: number): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();
        params.append('id', String(id));
        // params.append('_sort', String('-newnesses.created_at'));
        // params.append('_with', String('station,newnesses.user.employee'));
        //params.append('_with', String('citation_justification.user.employee'));
        const options = new RequestOptions({search: params, headers: this.headers});
        

        return this.http.get( `${this.apiUrl}/synergo-citations?${params}`,  options );
    }
    public infoSynergoRequisition(id: number): Observable<Response>{
        let params: URLSearchParams = new URLSearchParams();
        params.append('id', String(id));
        const options = new RequestOptions({search: params, headers: this.headers});
        return this.http.get( `${this.apiUrl}/synergo-requisitions/requisitionsAllLow?${params}`,  options );
    }
    public citationsTransferService(requisitionid:number, body: Object): Observable<Response> {
        return this.http.post( `${this.apiUrl}/synergo-citations/${requisitionid}/transfercitations`, JSON.stringify(body) , { headers: this.headers } );
    }
    public docsFromHVtoKaizenService( body: Object):Observable<Response>{
        return this.http.post(`${this.apiUrl}/hojasdevidas/CopyFilesfromHv`, JSON.stringify(body),{ headers: this.headers });
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/synergo-citation/synergo-citation.service.ts